module.exports = __webpack_public_path__ + "3526e0eee8ca217f52160369f8bd671e.pdf";